import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import "./BreakdownTracker.css";

const normalizeString = (str) => {
  return typeof str === "string" ? str.trim().toLowerCase() : "";
};

const camelize = (str) => {
  if (!str) return ""; 
  return str
    .toLowerCase() 
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const AddUser = () => {
  const [users, setUsers] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  // Add debounce effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchQuery(searchInput);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/users`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setUsers(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleAddUser = () => {
    navigate("/add-user-form");
  };

  const handleDeleteUser = async (userId) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        const token = localStorage.getItem("token");
        await axios.delete(
          `${process.env.REACT_APP_BASE_API_URL}/users/${userId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        alert("User deleted successfully!");
        fetchUsers();
      } catch (error) {
        console.error("Error deleting user:", error);
        alert("Failed to delete user.");
      }
    }
  };

  const filteredUsers = useMemo(() => {
    return users.filter(
      (user) =>
        normalizeString(user.name).includes(searchQuery.toLowerCase()) ||
        normalizeString(user.username).includes(searchQuery.toLowerCase()) ||
        normalizeString(user.email).includes(searchQuery.toLowerCase()) ||
        normalizeString(user.userrole).includes(searchQuery.toLowerCase())
    );
  }, [users, searchQuery]);

  return (
    <div className="breakdown-tracker-container">
      <div className="main-page-button-container">
        <button
          className="driver-navigate-button1"
          onClick={() => navigate("/main")}
        >
          Main Page
        </button>
      </div>
      <div className="breakdown-tracker-header">
        <button
          className="breakdown-tracker-add-button"
          onClick={handleAddUser}
        >
          <FaPlus className="add-icon" /> Add User
        </button>
        <input
          type="text"
          placeholder="Search..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          className="search-inputdriver"
        />
      </div>
      <div className="breakdown-tracker-table-container">
        <table className="breakdown-tracker-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Username</th>
              <th>Email</th>
              <th>User Role</th> {/* Added Role column */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user) => (
              <tr key={user.user_id}>
                <td>{user.name}</td>
                <td>{user.username}</td>
                <td>{user.email}</td>
                <td>
                  {user.userrole ? user.userrole.toUpperCase() : "N/A"}
                </td>{" "}
                {/* Handle null or undefined userrole */}
                <td>
                  <FaEdit
                    className="action-icon edit-icon"
                    title="Edit"
                    onClick={() => navigate(`/add-user-form/${user.user_id}`)}
                  />
                  <FaTrash
                    className="action-icon delete-icon"
                    title="Delete"
                    style={{ fontSize: "0.9rem", color: "lightcoral" }}
                    onClick={() => handleDeleteUser(user.user_id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddUser;
